import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

export default function Highlighted() {
  return (
    <div className="highlighted-card-wrapper">
      <div className="highlighted-card-content">
        <div className="highlighted-card-icon">
          <span>
            <FontAwesomeIcon icon={faCheck} />
          </span>
        </div>
        <div className="highlighted-card-desc ps-3">
          <p className="mb-0">
            High standards of professionalism, integrity Establishment.
          </p>
        </div>
      </div>
    </div>
  );
}
